import { ensureFavicon } from './favicon';

// Global favicon manager that ensures favicon is always present
class GlobalFaviconManager {
  private intervalId: NodeJS.Timeout | null = null;
  private isInitialized = false;

  // Initialize the favicon manager
  init() {
    if (this.isInitialized) return;
    
    console.log('🚀 Initializing Global Favicon Manager');
    
    // Set favicon immediately
    ensureFavicon();
    
    // Set up periodic checks to ensure favicon stays
    this.intervalId = setInterval(() => {
      const favicon = document.querySelector('link[rel="icon"]');
      if (!favicon) {
        console.log('⚠️ Favicon missing, restoring...');
        ensureFavicon();
      }
    }, 5000); // Check every 5 seconds
    
    // Handle page focus/blur events
    window.addEventListener('focus', () => {
      ensureFavicon();
    });
    
    // Handle page load events
    window.addEventListener('load', () => {
      ensureFavicon();
    });
    
    // Handle DOM content loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        ensureFavicon();
      });
    }
    
    this.isInitialized = true;
    console.log('✅ Global Favicon Manager initialized');
  }
  
  // Cleanup
  destroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.isInitialized = false;
    console.log('🛑 Global Favicon Manager destroyed');
  }
  
  // Force refresh favicon
  refresh() {
    ensureFavicon();
  }
}

// Create singleton instance
const globalFaviconManager = new GlobalFaviconManager();

export default globalFaviconManager;
